import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
//import { CadenasService } from 'src/app/aplicaciones-modulos/presupuesto-sellout/services/cadenas.service';
//import { CatalogoCadenasService } from 'src/app/aplicaciones-modulos/presupuesto-sellout/services/catalogo-cadenas.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';
import { IndicadoresVivosVModel, IndicadoresVivosVModelInterface } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';
import { VersionesService } from '../../services/versiones.service';
import { ClienteService } from '../../../balanza/services/cliente.service';
import { MaterialService } from '../../../balanza/services/material.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';


@Component({
  selector: 'app-mantenedor-presu-propiedades',
  templateUrl: './mantenedor-presu-propiedades.component.html',
  styleUrls: ['./mantenedor-presu-propiedades.component.css']
})
export class MantenedorPresuJerarquiaComponent implements OnInit {

  tituloCard: string = 'Mantenedor Presupuesto Jerarquia-Propiedades';
  tituloForm: string = 'Lista De Presupuesto Jerarquia-Propiedades';

  formulario: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;

  //buscador grid
  textoBuscar: string;

  cmbPeriodo: { clave: number; valor: string; }[];

  year = (new Date()).getFullYear();

  cmbAnio = [
    { clave: this.year, valor: this.year.toString() },
    { clave: this.year + 1, valor: (this.year + 1).toString() },
    { clave: this.year + 2, valor: (this.year + 2).toString() },
  ];

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  modelGrid         : IndicadoresVivosVModelInterface;
  cmbTipoDocumento  : { clave: number; valor: string; }[];
  cmbMeses          : { clave: number; valor: string; }[];
  comboJerarquia    : [];

  private DOC_CANAL_MODERNO: number = 1;
  private DOC_CANAL_TRADICIONAL: number = 2;
  private STATUS_UPDATE: string = "420";
  mesDescripcion: string = '';

  cmbTipoDePresupuesto: any[] = [
    { clave: 1, valor: 'LE-COMERCIAL' },
    { clave: 2, valor: 'LE-COMISIONES' }
  ]

  //isPresupuestoPropiedades = false;

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _indicadores: IndicadoresVivosService,
    private _catalogo: CatalogoIndicadoresService,
    private clienteS: ClienteService,
    private materialS: MaterialService,
    private dmaestros: DatosMaestrosService
  ) { }

  ngOnInit() {

    this.modulo = indicadoresVivosModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    this.cmbTipoDocumento = this._catalogo.catalogoTipoDocumento();
    this.cmbMeses = this._catalogo.catalogoMeses();
    const innClase = new IndicadoresVivosVModel();
    this.modelGrid = innClase.devolverGrid();

    this.formulario = this.fb.group({
      anio: ['', [Validators.required, Validators.min(2021), Validators.maxLength(4), Validators.minLength(4)]],
      mes: ['', [Validators.required]],
      material: ['', [Validators.required, Validators.maxLength(10)]],
      jerarquia: ['', [Validators.required]],
      codigoVendedor: ['', [Validators.required, Validators.maxLength(10)]],
      nombreMaterial: ['', [Validators.required]],
      jerarquiaDescripcion: ['', [Validators.required]],
      nombreVendedor: ['', [Validators.required]],
      dolares: ['', [Validators.min(1), Validators.maxLength(8)]],
      kilos: [''],
      cajas: [''],
      usuario: ['', [Validators.required]],
      fechaCarga: ['', []]
    });


    this.cargarGridcomponent();
    this.getIndicadores();
    this.cmbPeriodo = this._catalogo.catalogoMeses();
    //this.initComboSuCategorias();
    
  }

  dolaresKilosCajasValidacion = false;

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  /* FUNCIONES */
  changeTipoDocumento() {
    const tipo = this.formulario.get('tipo').value;
    if (tipo === this.DOC_CANAL_MODERNO) {
      this.formulario.get('codigoCliente').setValidators([Validators.required]);
      this.formulario.get('codigoCliente').setValue('');
    } else if (tipo === this.DOC_CANAL_TRADICIONAL) {
      this.formulario.get('codigoCliente').clearValidators();
      this.formulario.get('codigoCliente').setValue('');
    }
  }

  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Año',
        field: 'anio',
        filter: true,
        width: 120,
      },
      {
        headerName: 'Mes',
        field: 'mesDescripcion',
        sortable: true,
        width: 160,
        filter: true,
      },
      {
        field: 'codigoVendedor',
        sortable: true,
        width: 150,
        filter: true,
      },
      {
        field: 'nombreVendedor',
        sortable: true,
        width: 250,
        filter: true,
      },
      {
        field: 'jerarquia',
        sortable: true,
        width: 150,
        filter: true,
      },
      {
        field: 'jerarquiaDescripcion',
        sortable: true,
        width: 250,
        filter: true,
      },
      {
        headerName: 'Material Referencua',
        field: 'material',
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: 'Nom.Material',
        field: 'materialDescripcion',
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: 'Cajas',
        field: 'cajas',
        sortable: true,
        width: 150,
        filter: true,
      },
      {
        headerName: 'Kilos',
        field: 'kilos',
        sortable: true,
        width: 150,
        filter: true,
      },
      {
        headerName: 'DOLARES',
        field: 'dolares',
        sortable: true,
        width: 150,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        pinned: 'right',
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        pinned: 'right',
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.editableForm = false;
    this.formulario.reset();
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.formulario.get('usuario').setValue(userData.login2);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Crear Nuevo Registro de Presupuesto Jerarquia';

    this.openModal();
  }

  editar({ rowData }) {
    // debugger
    console.log('editar', rowData);
    this.editableForm = true;

    this.formulario.reset();
    this.formulario.patchValue(rowData);

    if(rowData.material){
      this.formulario.get("material").setValue(rowData.material);
      this.onChangeMaterial(rowData.material);
    }

    this.formulario.get("codigoVendedor").setValue(rowData.codigoVendedor);
    this.onChangeVendedor(rowData.codigoVendedor);
    this.openModal();
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      if (this.editableForm) {
        this.actualizar();
      } else {
        this.guardar();
      }
    } else {
      this.limpiarRegresar();
      this.closeModal();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Presupuesto Jerarquia-Propiedades';
    this.tituloForm = 'Lista De Presupuesto Jerarquia-Propiedades';
  }

  /** SERVICIOS */
  getIndicadores() {
    this.listaVacia = true;
    this.loading = true;
    this._indicadores.presupuestoPropiedadesList().subscribe((res: IndicadoresVivosVModel[]) => {
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
      console.log("this.rowData", this.rowData)
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {
    this.loading = true;

    this._utils.confirmarSincronoPromesa({
      title: this.DAT_MSG.eliminar,
      text: rowData.id,
      action: this.DAT_BTNS.eliminar,
      funcion: this._indicadores.presupuestoPropiedadesDelete(rowData),
    }).then((res: any) => {
        this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
    }).catch((error) => {
        this.loading = false;
    });

  }

  guardar() {
    let data = this.formulario.value;
    data.fechaCarga = new Date(); 
    this.formulario.reset();
    
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._indicadores.presupuestoPropiedadesCreate(data),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.closeModal();
      this.getIndicadores();
    }).catch((err) => {
      if (err.error.key === this.STATUS_UPDATE) {
        this.actualizarRegistroExistente();
      }
    });
  }

  actualizar() {
    console.log("this.formulario.value", this.formulario.value)
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._indicadores.presupuestoPropiedadesUpdate(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getIndicadores();
      //document.getElementById('cerrarModal').click();
      this.closeModal();
    }).catch((err) => {
      this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizarRegistroExistente() {
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: `El registro ya se encuentra registrado, Desea actualizar nuevamente el registro.`,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._indicadores.presupuestoPropiedadesUpdate(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getIndicadores();
    }).catch((err) => {
      this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  downloadDataCsv() {
    let data: any = [];
    let cabecera: any[] = [['Anio', 'Mes', 'Cod.Vendedor', 'Nom.Vendedor', 'Cliente', 'Nom.Cliente', 'Cod.Articulo', 'Articulo', 'Unidades', 'Dolares', 'Kilos']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      data.push(
        {
          anio: e.anio,
          mesDescripcion: e.mesDescripcion,
          codigoVendedor: e.codigoVendedor,
          nombreVendedor: e.nombreVendedor,
          codigoCliente: e.codigoCliente,
          nombreCliente: e.nombreCliente,
          codigoArticulo: (e.contenedor === undefined) ? `${e.codigoArticulo}` : `${e.codigoArticulo} / ${e.contenedor}`,
          nombreArticulo: e.nombreArticulo,
          unidades: e.unidades,
          dolares: e.dolares,
          kilos: e.kilos
        }
      );
    });
    let name: string = "reporte-mantenedor.csv";
    this._utils.exportCSV(cabecera, data, name);
    this._utils.mensajeOKToast('El archivo csv se exporto correctame.');
  }

  keyOnly2deciamls(event: any) {
    console.log("keyOnly2deciamls", event);
    console.log("keyOnly2deciamls", this.formulario.get("ventaBruta").value);

    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    if (this.formulario.get("ventaBruta").value != null) {
      if ((this.formulario.get("ventaBruta").value).indexOf('.') >= 0) {
        var dotPos = (this.formulario.get("ventaBruta").value).split(".");
        if (dotPos[1].length > 0) {
          if (dotPos[1].length >= 2) {
            return false;
          }
        }
      }
    }

    return true;
  }

  onChangeMaterial(event: any) {
    console.log("onChangeMaterial");
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;

    this.formulario.get('jerarquia').setValue('');
    this.formulario.get('jerarquiaDescripcion').setValue('');
    this.formulario.get('nombreMaterial').setValue('');

    this.materialS.obtenerPorId(this.formulario.get("material").value.trim()).subscribe(
      (resp) => {
        if (resp) {
          this.formulario.get('nombreMaterial').setValue(resp.dscaMaterial);
          if(resp.subCategoria)
            this.formulario.get('jerarquia').setValue(resp.subCategoria.idSubCategoria);
            this.formulario.get('jerarquiaDescripcion').setValue(resp.subCategoria.descripcionSubCategoria);
        }        
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  onChangeVendedor(event: any) {
    console.log("onChangeVendedor")
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    if (this.formulario.get("codigoVendedor").value != null && this.formulario.get("codigoVendedor").value.length > 0) {
      this._indicadores.getVendedor(this.formulario.get("codigoVendedor").value.trim()).subscribe(
        (resp) => {
          if (resp) {
            this.formulario.controls['nombreVendedor'].setValue(resp.nombreVendedor1);
          } else {
            this.formulario.controls['nombreVendedor'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.formulario.controls['nombreVendedor'].setValue('');
        }
      );
    }
  }


  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  initComboSuCategorias() {
    this.comboJerarquia = [];
    this.dmaestros.getAllSubCategorias().subscribe(
      (resp) => {
        console.log("SubCategorías", resp);
        this.comboJerarquia = resp;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );      
  }

}
